import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { PieChart } from '@/common/dashboard/charts/PieChart';
import { navigateToInvList } from '@/sc/entities/mcoInv/dashboard/inv/NavigateToInvList';
import { useNavState } from '@/common/navState/NavStateContext';

export const McoInvProgressChart = ({ selectedPeriod, selectedPbms, selectedCtrts, selectedDueDates }) => {

   const { navigateTo } = useNavState();

  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    const pbmIds = selectedPbms.map(pbm => pbm.id);
    const ctrtIds = selectedCtrts.map(ctrt => ctrt.id);
    const dueDates = selectedDueDates.map(dueDate => dueDate.value);
    const reqParam = {
      periodId: selectedPeriod?.id,
      pbmIds,
      ctrtIds,
      dueDates
    };
    
    rsrc.data('sc', 'MCO_INV_PROGRESS_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });
  }, [selectedPeriod, selectedPbms, selectedCtrts, selectedDueDates]);

  if (!data) return null;

  return (
    <PieChart
    data={ data }
    onClick={(dataPoint) => navigateToInvList(dataPoint, selectedPeriod, selectedPbms, selectedCtrts, navigateTo)}
    />
  );
};
